// Code taken from https://stackblitz.com/edit/try-react-reparent-demo?file=src%2FApp.tsx
import React, { useCallback, useRef, useState } from 'react';
import { context } from 'utils/videoSwapUtils/transportContext';

type Props = {
  children: React.ReactNode;
};

// group name => container
// container => parentNode

export function TransportProvider({ children }: Props) {
  // const [groups, setGroups] = useState<Map<string, HTMLElement>>(new Map());
  const groups = useRef<Map<string, HTMLElement>>(new Map());
  const [actives, setActives] = useState(new Set<string>());
  const register = useCallback((id: string, container: HTMLElement) => {
    if (groups.current.has(id)) {
      return groups.current;
    } else {
      groups.current.set(id, container);
    }
    return groups.current;
  }, []);
  const unregister = useCallback((id: string) => {
    if (!groups.current.has(id)) {
      return groups.current;
    } else {
      groups.current.delete(id);
    }
    return groups.current;
  }, []);
  // from node contains the real content
  // to node is anchored
  const swapNode = useCallback((from: string, to: string) => {
    if (!groups.current.has(from) || !groups.current.has(to)) return;
    const toNode = groups.current.get(to)!;
    const fromNode = groups.current.get(from)!;

    if (!toNode.parentNode || !fromNode.parentNode) return;

    const swapNode = document.createElement('div');
    const availableFromNode = fromNode.parentNode.replaceChild(swapNode, fromNode);
    const availableToNode = toNode.parentNode.replaceChild(availableFromNode, toNode);

    swapNode.parentNode!.replaceChild(availableToNode, swapNode);

    setActives((actives) => {
      actives.delete(from);
      actives.add(to);
      return new Set(actives);
    });
  }, []);
  return (
    <context.Provider value={{ actives, groups: groups.current, register, unregister, swapNode }}>
      {children}
    </context.Provider>
  );
}
